module.exports = require('./helpers/bundle-url').getBundleURL('kcZ9N') + "assets/" + require('./helpers/bundle-manifest').resolve("ahnKZ");